// extracted by mini-css-extract-plugin
export default {"title":"CustomTitle_title__0wmoO","light":"CustomTitle_light__iwtXi","dark":"CustomTitle_dark__4tA6I"};